import type { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { type DailyCorrectionValues, dailyCorrectionSchema } from './correction.schema'

type Submit = ReturnType<UseFormReturn<DailyCorrectionValues>['handleSubmit']>
type Props = Omit<UseFormProps<DailyCorrectionValues>, 'resolver'> & {
  onSubmit: SubmitHandler<DailyCorrectionValues>
  children: (form: UseFormReturn<DailyCorrectionValues>, submit: Submit) => React.ReactNode
}

export const DailyCorrectionForm = ({ onSubmit, children, ...options }: Props) => {
  const form = useFormWithSchema({ mode: 'all', ...options }, dailyCorrectionSchema)
  const submit = form.handleSubmit(onSubmit)
  return (
    <Form {...form}>
      <form onSubmit={submit}>{children(form, submit)}</form>
    </Form>
  )
}
